const { getAgeFromSsn } = require('./get-age-from-ssn')
const { getBirthdateFromSsn } = require('./get-birthdate-from-ssn')
const { getFullSsn } = require('./get-full-ssn')
const { getGenderFromSsn } = require('./get-gender-from-ssn')
const { removeSsnYearPrefix } = require('./remove-ssn-year-prefix')

module.exports = {
  getAgeFromSsn,
  getBirthdateFromSsn,
  getFullSsn,
  getGenderFromSsn,
  removeSsnYearPrefix
}
